<template>
  <div class="download-container">

    <div class="download-content">
      <span class='download-title'>立即下载优领课授课助手</span>
      <span class="download-desc">体验课件远程控制 , 本地云文件双向同步</span>
      <div> <button class="download-btn" @click="handlerDownload">下载优领课授课助手</button> </div>
    </div>
    <div class="tip">
      仅支持<span>3.20版本以上优领课授课端</span>使用
    </div>

    <div class="wechat-tip" @click.stop="showWechatTip=false" v-show="showWechatTip">
      <img src="../../assets/download/download-tip.svg" />
    </div>
  </div>

</template>

<script>
export default {
  name: "downloadPage",
  components: {

  },
  wath: {

  },
  data() {
    return {
      showWechatTip: false
    };
  },
  created() {
    this.initTip()
  },
  methods: {

    initTip() {
      let clientType = this.broswerType();
      // if ('android' == clientType) {
      //
      // } else
      if ('wechat' == clientType) {
        this.openWechatTip()
      } else {
        console.log('找不到浏览器类型' + navigator.userAgent)
      }

    },

    handlerDownload() {
      let clientType = this.broswerType();
      if ('android' == clientType) {
         //安卓机型复杂，替换为 <a 标签下载
        this.createDownDocument("/rsapp/")
      } else if ('ios' == clientType) {
        console.log('ios');
        //ios也先下载apk
        window.location.href = "/resapi/iosdown"
      } else if ('wechat' == clientType) {
        this.openWechatTip()
      } else {
        console.log('找不到浏览器类型' + navigator.userAgent)
      }

    },

    broswerType() {
      let ua = navigator.userAgent;
      console.log('浏览器类型' + ua)
      if (/microMessenger/i.test(ua)) {
        return 'wechat'
      } else if (/(iPhone|iPad|iPod|IOS)/i.test(ua)) {
        return 'ios';
      } else if (/android/i.test(ua)) {
        return 'android'
      } else {
        return 'android'
      }

    },
    //微信下载提示
    openWechatTip() {
      this.showWechatTip = true
    },
    //不用window.location.href 方案，避免部分机型闪屏
    createDownDocument(path) {
      if (document.getElementById('downhref')) {
          document.body.removeChild(document.getElementById('downhref'))
      }
      var a = document.createElement('a');
      a.setAttribute('href', path)
      a.setAttribute('download', 'RG_SmartclassResource.apk'); //必须要附带名字，不然部分机型，不自动识别为apk包
      a.setAttribute('target', '_blank');
      a.setAttribute('id', 'downhref')
      a.style.visibility = 'hidden';
      document.body.appendChild(a);
      a.click();
    }

  }
}
</script>

<style lang="scss" scoped>
.download-container {
  position: relative;
  height: 100%;
  background: url(../../assets/download/download-bg.svg) no-repeat center top;
  background-size: 80%;
  min-height: 550px;
}
@media screen and (min-width: 768px) {
  .download-container {
    position: relative;
    height: 100%;
    background: url(../../assets/download/download-bg.svg) no-repeat center top;
  }
}
.download-content {
  position: relative;
  top: 60%;
  display: flex;
  flex-direction: column;
  text-align: center;
  span {
    display: block;
  }
  .download-title {
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 28px;
  }
  .download-desc {
    margin-top: 24px;
    margin-bottom: 35px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    text-align: center;

    color: #909599;
  }
}
.download-btn {
  background: #20ccc6;
  mix-blend-mode: normal;
  box-shadow: 0px 0px 15px rgba(53, 194, 190, 0.2);
  border-radius: 24px;

  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  text-align: center;
  color: #ffffff;
  padding: 10px 20px;
  border: none;
}

.wechat-tip {
  position: fixed;
  left: 0;
  top: 0;
  background: #000000;
  opacity: 0.6;
  width: 100%;
  height: 100%;
  z-index: 100;
  text-align: center;
  img {
     width: 80%;
     margin-top: 10px;
     margin-left: auto;
     margin-right: auto;

  }
}
.tip{
  position: absolute;
  left: 0;
  right: 0;
  bottom: 30px;
  text-align: center;
  font-size: 14px;
  color: #909599;
  font-weight: 400;
  span{
    color: #258ce6;
  }
}
</style>